import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const ApprovalCompOff = () => {
  const navigate = useNavigate();
  const [ApproveCompOff, setApproveCompOff] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [respStatus, setRepStatus] = useState(0);
    const [apiStatus, setApiStatus] = useState(undefined)

  const columns = {
    Name: { text: "Employee", visible: "true" },
    FromDate: { text: "From Date", align: "center", visible: "true" },
    ToDate: { text: "To Date", align: "center", visible: "true" },
    Project: { text: "Project", visible: "true" },
    Purpose: { text: "Purpose", visible: "true" },
    TXNDate: { text: "Applied Date", align: "center", visible: "true" },
    ApplicationStatus: { text: "Status", visible: "true" },
  };
  const defaultColumns = {
    Name: true,
    TXNDate: true,
    Purpose: true,
    ToDate: true,
    FromDate: true,
    Project: true,
    ApplicationStatus: true,
  };

  const fetchCompOffLeave = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}compOffApprovalsList`);
        setApiStatus(response?.status)
      if (response.status === 200) {
        const compOffData = response?.data?.result;
        setApproveCompOff(compOffData);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  useEffect(() => {
    fetchCompOffLeave();
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Approve Comp Off"));
  }, []);

  const handleApproveModel = (id) => {
    setSelectedLeaveId(id.ID);
    setShowModal(true);
  };

  const handleRejectModel = (id) => {
    setSelectedLeaveId(id.ID);
    setRejectModal(true);
  };
  const handleApprove = async (event) => {
  event.preventDefault();
  setIsLoading(true);
  await leaveStatus(826);
  setIsLoading(false);
};
  const [remarkValue, setRemarkValue] = useState("");

const handleReject = async (event) => {
  event.preventDefault();
  setIsLoading(true);
  await leaveStatus(827);
  setIsLoading(false);
};

  const leaveStatus = (status) => {
     return PostServiceCaller(
      `${API_URL}managerCompOffApproval/${selectedLeaveId}`,
      {
        ApplicationStatus_123: status,
        ActionRemarks: remarkValue,
      },
      "post"
    )
      .then((response) => {
        if (status === 826) {
          toast.success("Comp-Off Approved Successfully!");
        } else if (status === 827) {
          toast.success("Comp-Off Rejected Successfully!");
        }
        fetchCompOffLeave();
        setShowModal(false);
        setRejectModal(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleView = (id) => {
    navigate(`/apply-comp-off/view/${id.ID}`);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={ApproveCompOff}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              showIcon2={true}
              showIcon3={true}
              isSorting={true}
              isActionRequired={true}
              handleIcon1={handleView}
              handleIcon2={handleApproveModel}
              handleIcon3={handleRejectModel}
              add
              more
              function
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View",
                Icon2: <i className="fa fa-check"></i>,
                Icon2Text: "Approved CompOff",
                Icon3: <i className="fa fa-close"></i>,
                Icon3Text: "Reject CompOff",
              }}
            />
          </div>
          {/* Approve Form */}
          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Approve</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setShowModal(false)}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-2">
                    <form onSubmit={handleApprove}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            onChange={(e) => setRemarkValue(e.target.value)}
                            placeholder="Remark"
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn-sm" disabled={isLoading}>
                          {isLoading ? "Approving..." : "Approve"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Reject Form */}
          {rejectModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Reject</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setRejectModal(false)}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-2">
                    <form onSubmit={handleReject}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            placeholder="Remark"
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setRejectModal(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn-sm" disabled={isLoading}>
                          {isLoading ? "Rejecting..." : "Reject"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ApprovalCompOff;